import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass/styled-components';
import styled from 'styled-components';
import { FiXCircle } from 'react-icons/fi';
import theme from 'styled-theming';

const textColor = theme('mode', {
  light: (props) => props.theme.colors.lightGrey,
  dark: (props) => props.theme.colors.white,
});

const hoverColor = theme('mode', {
  light: (props) => props.theme.colors.warningDark,
  dark: (props) => props.theme.colors.warning,
});

const DeleteWrapper = styled(Flex)`
  transition: ${(props) => props.theme.animation.quick};
  cursor: pointer;
  color: ${textColor};
  &:hover {
    color: ${hoverColor};
  }
`;

const Icon = styled(FiXCircle)`
  stroke-width: 1.5px;
`;

function Delete(props) {
  const { onClick } = props;
  return (
    <DeleteWrapper alignItems="center" onClick={onClick} data-testid="delete-button">
      <Icon size={18} />
      <Text ml={2} fontSize={1} fontWeight={300}>
        delete
      </Text>
    </DeleteWrapper>
  );
}

Delete.defaultProps = {
  onClick: undefined,
};

Delete.propTypes = {
  onClick: PropTypes.func,
};

export default Delete;
